import type { FC, ReactNode } from 'react'
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import type { LogoTrackProps } from '@segment/matcha/recipes/LogoCarousel/LogoTrack'

import FooterCompact from '@segment/templates/FooterCompact'

import type { SignUpBaseProps } from 'data/signUp'

import Layout from '@segment/next-shared/layout'

import Navigation from './components/Navigation'
import Hero from './components/Hero'
import GettingStarted from './components/GettingStarted'
import MainSection from './components/MainSection'

import PlanFeatures from './components/PlanFeatures'
import SeeHowYouCan from './components/SeeHowYouCan'

import ogImagePng from './assets/OgImage.png'

export interface SignUpViewProps extends SignUpBaseProps {
  logos: LogoTrackProps[`icons`]
  image: ReactNode
  testimonialLogo: ReactNode
}

const SignUpView: FC<SignUpViewProps> = (props) => {
  const { hero, main, logos, playbook, metadata, image, testimonialLogo } = props

  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle={metadata.title}
        pageDescription={metadata.description}
        themeColor={theme.palette.twilio.gray[10]}
        bodyBackground={theme.palette.twilio.gray[10]}
        pageOG={ogImagePng}
      >
        <Navigation />
        <Hero {...hero} />
        <Main>
          <MainSection {...main} image={image} />
          <PlanFeatures logos={logos} />
          <SeeHowYouCan playbook={playbook} testimonialLogo={testimonialLogo} />
        </Main>
        <GettingStarted />
        <FooterCompact />
      </Layout>
    </AppearanceProvider>
  )
}

export default SignUpView

const Main = styled.main`
  overflow: hidden;
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`
